import React from 'react';

import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { spaceHeaderID } from './SpaceHeaderWithTotalItemsCount';
import { useHeaderTelemetry } from './UseHeaderTelemetryHook';

export function SpaceHeaderContent(props: { headerText: string, testId?: string, renderSideContent?: () => JSX.Element, onClick?: () => void }): JSX.Element {
    useHeaderTelemetry();

    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return <div className={FeatureFlags.compactHeaderEnabled ? ExplorerStyles.SpaceHeaderContentV2 : ExplorerStyles.SpaceHeaderContent} onClick={props.onClick}>
        <h1 id={spaceHeaderID} className={ExplorerStyles.SpaceHeaderText} data-tb-test-id={props.testId}>{props.headerText}</h1>
        {props.renderSideContent && props.renderSideContent()}
    </div>;
}